module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/founder_doctor/1-mobile-f84d5af5d35dcc7ef72bd1c45362b8f7.jpg";